import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router, NavigationStart, NavigationCancel, NavigationError, NavigationEnd } from '@angular/router';
import { MESSAGES } from 'src/app/constants/messages.constants';
// import { PopupService } from '@popup';

let loadingCount = 0;

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private $state: BehaviorSubject<boolean> = new BehaviorSubject(false);
  readonly changes = this.$state.asObservable();
  constructor(private $router: Router) {
    this.initRoutingLoader();
  }
  markAsLoading() {
    if (loadingCount === 0) {
      this.$state.next(true);
    }
    loadingCount += 1;
  }
  completeLoading() {
    if (loadingCount > 0) {
      loadingCount -= 1;
      this.$state.next(false);
    }
  }
  reset() {
    loadingCount = 0;
    this.$state.next(false);
  }
  initRoutingLoader() {
    this.$router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.markAsLoading();
      }
      else if ((event instanceof NavigationCancel || event instanceof NavigationError || event instanceof NavigationEnd)) {
        this.completeLoading();
      }
      if (event instanceof NavigationError) {
        console.log(event);
        
        let message = MESSAGES.OFFLINE;
        if (navigator.onLine) {
          message = MESSAGES.ERROR.UNKNOWN;
        }
        // this.$popup.error(message, {duration: 5000});
      }
    });
  }
}
